<div class="content-wrapper container-xxl p-0">
    <div class="row">
        <div class="content-body col-md-12">
            <br><br>
            <h1 style="text-align: center;"> Working on your order... </h1>
            <loader *ngIf="showLoader"></loader>
        </div>
    </div>
</div>